import LocalizedStrings from "react-localization";
// eslint-disable-next-line
import UpgradeIcon from "@mui/icons-material/Upgrade";

const strings = new LocalizedStrings({
  es: {
    optionStore: "Tienda",
    optionMessageCenter: "Centro de Mensajes",
    optionDiagrams: "Planos y Diagramas",
    optionMonitor: "Central de Monitoreo",
    optionDashboard: "Tableros",
    optionAlerts: "Alertas",
    optionRules: "Reglas",
    optionMaintenanceDashboard: "Tableros de Mantenimiento",
    optionEquipments: "Equipos",
    optionMaintenanceRequirement: "Solicitudes de Mantenimiento",
    optionServiceOrders: "Ordenes de Servicio",
    optionMaintenanceSchedules: "Programas de Mantenimiento",
    optionTools: "Herramientas",
    optionSpares: "Repuestos",
    optionIncomesAndExpenses: "Analizador de Ingresos y Costos",
    optionFailureAnalytics: "Analítica de Fallas",
    optionReports: "Reportes",
    optionForecast: "Predicciones",
    optionDataExporter: "Exportador de Datos",
    optionCompanies: "Empresas",
    optionDevices: "Dispositivos",
    optionParameters: "Parámetros",
    optionWorkRoutines: "Rutinas de Trabajo",
    optionVariables: "Variables",
    optionActions: "Acciones",
    optionGroups: "Grupos",
    optionRoles: "Roles",
    optionUsers: "Usuarios",
    optionHolidays: "Días festivos",
    optionCostCenter: "Centros de Costo",
    optionMaintenanceRoutines: "Rutinas de Mantenimiento",
  },
});

const menuItems = [
  // {
  //   name: strings.optionStore,
  //   to: "/store",
  //   icon: "StorefrontIcon",
  //   isAllowed: (perms) => perms?.includes("store:read"),
  //   category: "sales",
  // },
  // {
  //   name: strings.optionMessageCenter,
  //   to: "/messages",
  //   icon: "ChatIcon",
  //   isAllowed: (perms) => perms?.includes("message:read"),
  //   category: "sales",
  // },
  {
    name: strings.optionDevices,
    to: "/devices",
    icon: "BlurOnIcon",
    isAllowed: (perms) => perms?.includes("device:read"),
    category: "monitoring",
  },
  // {
  //   name: strings.optionDiagrams,
  //   to: "/diagrams",
  //   icon: "ViewInArIcon",
  //   isAllowed: (perms) => perms?.includes("diagram:read"),
  //   category: "monitoring",
  // },
  {
    name: strings.optionMonitor,
    to: "/monitor",
    icon: "TrackChangesIcon",
    isAllowed: (perms) => perms?.includes("monitor:read"),
    category: "monitoring",
  },
  {
    name: strings.optionDashboard,
    to: "/dashboard",
    icon: "DashboardIcon",
    isAllowed: (perms) =>
      perms?.includes("dashboard:read") ||
      perms?.includes("dashboard:read-standard"),
    category: "monitoring",
  },
  {
    name: strings.optionAlerts,
    to: "/alerts",
    icon: "NotificationImportantIcon",
    isAllowed: (perms) =>
      perms?.includes("alert:read") || perms?.includes("alert:read-config"),
    category: "monitoring",
  },
  {
    name: strings.optionRules,
    to: "/rules",
    icon: "RuleIcon",
    isAllowed: (perms) =>
      perms?.includes("rule:read") || perms?.includes("rule:read-config"),
    category: "monitoring",
  },
  // {
  //   name: strings.optionMaintenanceDashboard,
  //   to: "/maintenance-dashboard",
  //   icon: "ViewKanbanIcon",
  //   isAllowed: (perms) => perms?.includes("maintenance-dashboard:read"),
  //   category: "maintenance",
  // },
  {
    name: strings.optionEquipments,
    to: "/equipments",
    icon: "DeviceHubIcon",
    isAllowed: (perms) => perms?.includes("equipment:read"),
    category: "maintenance",
  },
  // {
  //   name: strings.optionMaintenanceRequirement,
  //   to: "/maintenance-requirement",
  //   icon: "AssignmentIcon",
  //   isAllowed: (perms) => perms?.includes("maintenance-requirement:read"),
  //   category: "maintenance",
  // },
  {
    name: strings.optionServiceOrders,
    to: "/service-orders",
    icon: "HandymanIcon",
    isAllowed: (perms) => perms?.includes("service-order:read"),
    category: "maintenance",
  },
  {
    name: strings.optionMaintenanceSchedules,
    to: "/maintenance-schedules",
    icon: "CalendarMonthIcon",
    isAllowed: (perms) => perms?.includes("maintenance-schedule:read"),
    category: "maintenance",
  },
  {
    name: strings.optionTools,
    to: "/tools",
    icon: "BuildIcon",
    isAllowed: (perms) => perms?.includes("tool:read"),
    category: "maintenance",
  },
  {
    name: strings.optionSpares,
    to: "/spares",
    icon: "HomeRepairServiceIcon",
    isAllowed: (perms) => perms?.includes("spare:read"),
    category: "maintenance",
  },
  {
    name: strings.optionMaintenanceRoutines,
    to: "/maintenance-routines",
    icon: "EngineeringIcon",
    isAllowed: (perms) => perms?.includes("maintenance-routine:read"),
    category: "maintenance",
  },
  // {
  //   name: strings.optionIncomesAndExpenses,
  //   to: "/incomes-and-expenses",
  //   icon: "BalanceIcon",
  //   isAllowed: (perms) => perms?.includes("income-and-expense:read"),
  //   category: "analytics",
  // },
  // {
  //   name: strings.optionFailureAnalytics,
  //   to: "/failure-analytics",
  //   icon: "QueryStatsIcon",
  //   isAllowed: (perms) => perms?.includes("failure-analytic:read"),
  //   category: "analytics",
  // },
  // {
  //   name: strings.optionReports,
  //   to: "/reports",
  //   icon: "SummarizeIcon",
  //   isAllowed: (perms) => perms?.includes("report:read"),
  //   category: "analytics",
  // },
  // {
  //   name: strings.optionForecast,
  //   to: "/forecast",
  //   icon: "StackedLineChartIcon",
  //   isAllowed: (perms) => perms?.includes("forecast:read"),
  //   category: "analytics",
  // },
  // {
  //   name: strings.optionDataExporter,
  //   to: "/data-exporter",
  //   icon: "UpgradeIcon",
  //   isAllowed: (perms) => perms?.includes("data-exporter:read"),
  //   category: "analytics",
  // },
  {
    name: strings.optionCompanies,
    to: "/companies",
    icon: "ApartmentIcon",
    isAllowed: (perms) => perms?.includes("company:read"),
    category: "settings",
  },
  {
    name: strings.optionParameters,
    to: "/parameters",
    icon: "TuneIcon",
    isAllowed: (perms) => perms?.includes("parameter:read"),
    category: "settings",
  },
  // {
  //   name: strings.optionWorkRoutines,
  //   to: "/work-routines",
  //   icon: "ListAltIcon",
  //   isAllowed: (perms) => perms?.includes("work-routine:read"),
  //   category: "settings",
  // },
  {
    name: strings.optionVariables,
    to: "/variables",
    icon: "SelectAllIcon",
    isAllowed: (perms) => perms?.includes("variable:read"),
    category: "settings",
  },
  {
    name: strings.optionActions,
    to: "/actions",
    icon: "BoltIcon",
    isAllowed: (perms) => perms?.includes("action:read"),
    category: "settings",
  },
  {
    name: strings.optionCostCenter,
    to: "/cost-centers",
    icon: "AttachMoneyIcon",
    isAllowed: (perms) => perms?.includes("cost-center:read"),
    category: "settings",
  },
  {
    name: strings.optionHolidays,
    to: "/holidays",
    icon: "CelebrationIcon",
    isAllowed: (perms) => perms?.includes("holiday:read"),
    category: "settings",
  },
  {
    name: strings.optionRoles,
    to: "/roles",
    icon: "RuleIcon",
    isAllowed: (perms) => perms?.includes("role:read"),
    category: "settings",
  },
  // {
  //   name: strings.optionGroups,
  //   to: "/groups",
  //   icon: "GroupsIcon",
  //   isAllowed: (perms) => perms?.includes("group:read"),
  //   category: "settings",
  // },
  {
    name: strings.optionUsers,
    to: "/users",
    icon: "PeopleIcon",
    isAllowed: (perms) => perms?.includes("user:read"),
    category: "settings",
  },
];

export default menuItems;
